// Minimal RFC-4180 CSV builder. Pure; no dependencies.
const BOM = "\uFEFF"; // lets Excel detect UTF-8

// Neutralize spreadsheet formula injection: cells that start with a formula
// trigger get a leading single quote so Excel/Sheets treat them as text.
function guardFormula(text) {
  return /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
}

function escapeCell(value) {
  if (value === null || value === undefined) return "";
  const text = guardFormula(String(value));
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * Build a CSV string (BOM-prefixed, CRLF line endings).
 * @param {string[]} headers
 * @param {Array<Array<unknown>>} rows
 */
export function toCsv(headers, rows) {
  const lines = [headers, ...rows].map((row) => row.map(escapeCell).join(","));
  return BOM + lines.join("\r\n") + "\r\n";
}
